<template>
  <div class="customer-manage conmon-top special-customer">
    <el-container>
      <div style="padding: 0;width: 100%;" class="table-first-style">
        <div class="base-input ovf-hd" style="margin-bottom: 10px;">
          <el-row class="search-title" style="">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right customer-search-record">
              <span v-show="!hide" style="margin-left: 20px">筛选记录：</span>
              <el-select filterable v-show="!hide" v-model="searchValue" placeholder="筛选记录" style="margin-right: 30px;"
                class="customer-manage-search-item common-search-formtype" @change="searchOptionsChange"
                         @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                <el-option v-for="item in searchOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-button class="fold-button" type="text" @click="changeSearchType" v-show="hide">高级查询</el-button>
              <el-button class="fold-button simple-btn" type="text" @click="changeSearchType" v-show="!hide">简单查询
              </el-button>
              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i"></i>
              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" style="margin-right: 13px"></i>
              <el-button class="search-btn-new" type="primary" v-show="hide" size="small" @click="searchLoad">查询
              </el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide">
            <el-col :span="24" class="text-align-left">
              <span style="margin-left: 50px">输入搜索：</span>
              <el-input placeholder="客户名/手机号/微信昵称" @keyup.enter.native="searchLoad" v-model.trim="searchTmp.keywords"
                clearable></el-input>
            </el-col>
          </el-row>
          <!--高级查询-->
          <el-row class="search-content" style="min-height: 210px!important;height: auto" v-show="!hide">
            <div style="text-align: left;" class="hei-ser">
              <el-button type="primary" class="add-btn btn-right" @click="reset">重置</el-button>
              <el-button type="primary" class="add-btn" @click="saveSearchItem" style="margin-right:16px">保存筛选
              </el-button>
              <el-button type="primary" class="add-btn" @click="addQuery" style="margin-right:16px">保存为动态群组</el-button>
              <el-button type="primary" class="add-btn" @click="startSearchQuery" style="margin-right:16px">开始查询
              </el-button>
            </div>
            <div style="text-align: left;padding-bottom: 10px;height: 40px">
              <span style="margin-left: 20px;">查询条件:</span>
            </div>
            <higher-search
              class="common-search-formtype customer-manage-higher-search group-item-style high-search-cascader"
              :forSonTerms="forSonTerms" v-bind:allRelationshipSearch="allRelationshipSearch" @change="getAllTerms"
              style="margin-top: 10px"></higher-search>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0;">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>客户列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right">
            <el-button type="primary" class="add-btn btn-right" @click="downloadCustomer">导出客户</el-button>
            <el-button type="primary" class="add-btn list-btn-margin" @click="uploadCustomer" style="margin-left:0;">
              导入客户</el-button>
            <el-button type="primary" class="add-btn list-btn-margin" @click="openDialog">创建客户</el-button>
          </el-col>
        </el-row>
        <el-table ref="multipleTable" :data="tableData" class="table customer-table-style" v-loading="loadList">
          <!-- <el-table-column label="头像" width="180">
            <template slot-scope="scope">
            </template>
          </el-table-column> -->
          <el-table-column label="客户" min-width="120">
            <template slot-scope="scope">
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link"
                style="margin-left: 0;color:#4882ff;text-decoration: none">
                <img :src="scope.row.avatar | showImgUrl" alt=""
                  style="width: 32px;height: 32px;display: block;border-radius: 50%;text-align:left;float:left;margin-right:10px;">
                <span v-if="scope.row.realname" style="line-height: 32px;">{{ scope.row.realname }}</span>
                <span v-if="scope.row.realname === ''" style="line-height: 32px;">{{ scope.row.nickname }}</span>
                <span v-if="scope.row.realname === '' && scope.row.nickname === ''" style="line-height: 32px;">未知</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="source_name" label="初始来源" width="110"></el-table-column>
          <el-table-column label="当前等级" width="115">
            <template slot-scope="scope">
              <span v-if="!scope.row.stage_name">未知</span>
              <span>{{ scope.row.stage_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.join_date === 0">{{ scope.row.create_time | formatDate }}</span>
              <span v-else>{{ scope.row.join_date | formatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="地区" width="">
            <template slot-scope="scope">
              {{ scope.row.province_name }}{{ scope.row.city_name }}{{ scope.row.district_name }}
            </template>
          </el-table-column>
          <!--<el-table-column prop="name" label="创建路径" width=""></el-table-column>-->
          <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <!--<div class="op-link" @click="edit(scope.row)">-->
              <!--<i class="iconfont icon-icon-bianji" style="font-size: 14px"></i>-->
              <!--<span>编辑</span>-->
              <!--</div>-->
              <router-link :to="{ name: 'customerDetail', query: { id: scope.row.id }}" class="op-link"
                style="margin-left: 0;color:#4882ff;text-decoration: none">
                查看
              </router-link>
              <div class="op-link" @click="deleteItem(scope.row)">
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-container>
    <div class="table-foot" style="text-align: right">
      <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-size="limit" :current-page="page"
        layout="total, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>

    <!--添加弹窗-->
    <el-dialog class="cellDialog base-dialog" title="创建客户" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm">
        <el-form-item label="姓名:" :label-width="addLabelWidth" prop="name" :rules="[
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ]">
          <el-input class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入姓名">
          </el-input>
        </el-form-item>
        <el-form-item class="text-align-left" label="性别:" :label-width="addLabelWidth" prop="sex" :rules="[
            { required: true, message: '请选择性别', trigger: 'blur' }
          ]">
          <template>
            <el-radio-group v-model="addForm.sex">
              <el-radio :label="1" style="margin-left: 0;">男</el-radio>
              <el-radio :label="2" style="margin-left: 10px;">女</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="手机:" :label-width="addLabelWidth" prop="phone" :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' }
          ]">
          <el-input class="stockInput" type="text" v-model="addForm.phone" auto-complete="off" placeholder="请输入手机号">
          </el-input>
        </el-form-item>
        <el-form-item class="text-align-left" label="手机验证:" :label-width="addLabelWidth" prop="mobile_verified" :rules="[
            { required: true, message: '请选择手机验证', trigger: 'blur' }
          ]">
          <template>
            <el-radio-group v-model="addForm.mobile_verified">
              <el-radio :label="1" style="margin-left: 0;">是</el-radio>
              <el-radio :label="0" style="margin-left: 10px;">否</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="邮箱:" :label-width="addLabelWidth" prop="email" :rules="[
            { required: true, message: '请输入邮箱', trigger: 'blur' }
          ]">
          <el-input class="stockInput" type="text" v-model="addForm.email" auto-complete="off" placeholder="请输入邮箱">
          </el-input>
        </el-form-item>
        <el-form-item class="text-align-left" label="邮箱验证:" :label-width="addLabelWidth">
          <template>
            <el-radio-group v-model="addForm.email_verified">
              <el-radio :label="1" style="margin-left: 0;">是</el-radio>
              <el-radio :label="0" style="margin-left: 10px;">否</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="cancelAdd" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" :disabled="isDisabled" @click="submitForm('addForm')">确 定
        </el-button>
      </div>
    </el-dialog>
    <!--保存为动态群组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="保存为动态群组" :visible.sync="addGroup" width="520px">
      <el-form ref="addGroupForm" :model="addGroupForm" :rules="addGroupFormRules">
        <el-form-item label="群组名字:" prop="name" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="addGroupForm.name" auto-complete="off" placeholder="输入群组名字">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="addGroup = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledQuery" type="primary" @click="confirmAddGroup">确 定
        </el-button>
      </div>
    </el-dialog>
    <!--保存筛选条件弹窗-->
    <el-dialog class="cellDialog base-dialog" title="保存为筛选条件" :visible.sync="saveSearch" width="520px">
      <el-form ref="saveSearchForm" :model="saveSearchForm" :rules="saveSearchFormRules">
        <el-form-item label="条件名字:" prop="name" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="saveSearchForm.name" auto-complete="off"
            placeholder="输入筛选条件名字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="saveSearch = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledSearch" type="primary" @click="confirmSaveSearch">确 定
        </el-button>
      </div>
    </el-dialog>
    <!--点击导出按钮弹窗-->
    <el-dialog class="cellDialog base-dialog special-select-dialog" title="导出客户" :visible.sync="exportDialog"
      width="520px">
      <div class="export-number">
        当前导出人数: {{ exportNumber }}
      </div>
      <el-form ref="exportForm" :model="exportForm">
        <el-form-item label="选择属性:" :label-width="addLabelWidth" class="special-select-form-item">
          <el-select v-model="exportForm.chooseIdentities" multiple placeholder="请选择">
            <el-option v-for="item in identities" :key="item.identity" :label="item.name" :value="item.identity">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="isAllIdentity" label="全部属性:" :label-width="addLabelWidth">
          <el-checkbox v-model="checked">全选</el-checkbox>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="exportDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledExport" type="primary" @click="startDownload">确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerList, getSourceData, getCustomerStage, getGroupList, getBigWheelList, getWechatPublicListForNode, getQrCodeList, WePagesList, getMessageListForNode, getCustomerAttributeList, addCustomer, deleteCustomer, addGroup, getCustomerListHigher, saveQuerycondition, getQueryCondition, exportCustomer } from '@/api/customer.js'
import HigherSearch from './../common/higher-search.vue'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'customerManage',
  data () {
    return {
      inputFlagOne: null,
      saveSearchFormRules: {
        name: [
          { required: true, message: '群组名字不能为空', trigger: 'change' }
        ]
      },
      addGroupFormRules: {
        name: [
          { required: true, message: '群组名字不能为空', trigger: 'change' }
        ]
      },
      loadList: true,
      checked: false,
      isDisabledExport: false,
      exportDialog: false,
      exportChecked: false,
      exportForm: {
        chooseIdentities: []
      },
      identities: [],
      exportNumber: '',
      searchOptions: [],
      searchValue: '',
      tableData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      addGroup: false,
      saveSearch: false,
      addForm: {
        name: '',
        phone: '',
        sex: 1,
        mobile_verified: 0,
        email: '',
        email_verified: 0
      },
      addGroupForm: {
        name: ''
      },
      saveSearchForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchTmp: {
        keywords: ''
      },
      search: {
        keywords: ''
      },
      isDisabled: false,
      isDisabledQuery: false,
      isDisabledSearch: false,
      allTerms: {},
      lastId: 0,
      searchType: 0,
      allRelationshipSearch: '',
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ],
      result: [],
      len: 0,
      changeSearchValue: '',
      isShowSearchRes: false,
      is_searched: false
    }
  },
  components: {
    'higher-search': HigherSearch
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ])
  },
  methods: {
    ...mapMutations([
      'setQuery'
    ]),
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    searchLoad () {
      this.page = 1
      this.search = JSON.parse(JSON.stringify(this.searchTmp))
      this.lastId = 0
      this.load()
    },
    // 筛选条件select查询
    searchOptionsChange (value) {
      this.loadList = true
      if (value === '') {
        this.page = 1
        this.searchType = 0
        this.lastId = ''
        this.load()
      } else {
        this.page = 1
        let termsArr = {}
        this.changeSearchValue = value
        for (let item of this.searchOptions) {
          if (item.id == value) {
            termsArr = item.query
          }
        }
        getCustomerList(this.page, this.lastId, termsArr).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data.list
            this.result = []
            for (let i = 0; i < data.length; i += 10) {
              this.result.push(data.slice(i, i + 10))
            }
            // 计算总体请求数据的长度
            this.len = 0
            for (let item of this.result) {
              this.len = this.len + item.length
            }
            this.tableData = this.result[0]
            this.totalCount = res.data.data.count
            this.exportNumber = res.data.data.count
          }
        })
        this.loadList = false
        this.searchType = 2
      }
    },
    getQueryconditionAction () {
      getQueryCondition().then((res) => {
        if (res.data.code === 0) {
          res.data.data.list.unshift({
            id: '',
            name: '全部',
            query: {
              keywords: ''
            }
          })
          this.searchOptions = res.data.data.list
        }
      })
    },
    // 获取客户属性
    getCustomerAttributes () {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          this.identities = res.data.data
        }
      })
    },
    // 导出弹窗打开
    downloadCustomer () {
      this.exportDialog = true
      // this.exportNumber = this.len
    },
    // 开始下载
    startDownload () {
      console.log(this.exportForm, '导出')
      // 判断数量
      if (this.customerCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      // if (this.customerCount > 1000000) {
      //   _g.toastMsg('error', '最多导出100万条数据，请重新选择')
      //   return
      // }
      if (this.exportForm.chooseIdentities.length === 0 && this.checked === false) {
        _g.toastMsg('error', '请选择要导出的客户属性')
        return
      }

      let search = {}
      // 开始传导出的查询参数
      if (this.hide === false) {
        for (let item of this.allTerms.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            // one.option = null
            one.relationOptions = null
            one.optionOther = null
            one.qrcodeOptions = null
            one.templateOption = null
          }
        }
        search = this.allTerms
      } else {
        search = this.search
      }
      // 是否全选
      let gold = {}
      if (this.checked === false) {
        // 属性集合
        for (let item of this.identities) {
          for (let one of this.exportForm.chooseIdentities) {
            if (item.identity === one) {
              gold[one] = item.name
            }
          }
        }
      } else {
        // 属性集合
        for (let item of this.identities) {
          gold[item.identity] = item.name
        }
      }
      if (Object.keys(gold).length > 0) {
        // 发送下载参数
        exportCustomer(search, gold).then(response => {
          _g.toastMsg('href', '')
          this.exportDialog = false
        }).catch((error) => {
          _g.toastMsg('error', error)
        })
      }
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 改变查询类型
    changeSearchType () {
      this.hide = !this.hide
      if (this.hide === false) {
        this.search.keywords = ''
        this.page = 1
        this.lastId = 0
        this.searchType = 0
        this.load()
      } else {
        this.page = 1
        this.lastId = 0
        this.load()
      }
    },
    // 重置
    reset () {
      this.loadList = true
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
      this.page = 1
      this.lastId = ''
      this.allTerms.termsGroup = this.forSonTerms
      this.searchValue = ''
      this.load()
      this.setQuery({})
    },
    // 导入客户
    uploadCustomer () {
      router.push('/home/import-data')
    },
    // 打开保存筛选弹窗
    saveSearchItem () {
      this.saveSearch = true
    },
    // 确认添加为动态群组
    confirmAddGroup () {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].start_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].end_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 需要选内容的
            //              if (
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
            //              ) {
            //                if (item.terms[j].value === '') {
            //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
            //                  return
            //                }
            //              }
            // 如果是微信回复
            if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
              if (item.terms[j].value === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                return
              }
              if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                return
              }
            }
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              console.log('102')
              if (item.terms[j].selectedOptions[1] !== 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                }
              }
              if (item.terms[j].selectedOptions[1] === 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent.length === 0) {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                  if (yi.attributeRelation === 'gtele') {
                    if (yi.attrValTimeStart === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                      return
                    }
                    if (yi.attrValTimeEnd === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                      return
                    }
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          // one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
        }
      }
      // 防止重复点击
      this.isDisabledQuery = true
      // 过滤不必要的参数
      // let termData = _g.getCondition(this.allTerms)
      addGroup(this.addGroupForm.name, 1, this.allTerms).then((res) => {
        if (res.data.code === 0) {
          this.isDisabledQuery = false
          this.addGroup = false
          router.push('/home/group-manage')
          _g.toastMsg('success', '添加群组成功')
        } else {
          this.isDisabledQuery = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取子组件的查询条件
    getAllTerms (value) {
      this.allTerms = value
      console.log('000', value)
    },
    // 确认保存筛选条件
    confirmSaveSearch () {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].start_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].end_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 需要选内容的
            //              if (
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
            //              ) {
            //                if (item.terms[j].value === '') {
            //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
            //                  return
            //                }
            //              }
            // 如果是微信回复
            if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
              if (item.terms[j].value === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                return
              }
              if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                return
              }
            }
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              console.log('102')
              if (item.terms[j].selectedOptions[1] !== 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                }
              }
              if (item.terms[j].selectedOptions[1] === 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent.length === 0) {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                  if (yi.attributeRelation === 'gtele') {
                    if (yi.attrValTimeStart === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                      return
                    }
                    if (yi.attrValTimeEnd === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                      return
                    }
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          // one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
        }
      }
      // 过滤不必要的参数
      // let termData = _g.getCondition(this.allTerms)
      if (this.saveSearchForm.name === '') {
        _g.toastMsg('error', '筛选条件名字不能为空')
        return
      }
      saveQuerycondition(this.saveSearchForm.name, this.allTerms).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '添加成功')
          this.saveSearch = false
          this.getQueryconditionAction()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 保存为动态群组
    addQuery () {
      this.addGroup = true
    },
    // 点击开始查询
    startSearchQuery () {
      this.isShowSearchRes = false
      this.searchType = 1
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].start_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].end_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 需要选内容的
            //              if (
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
            //              ) {
            //                if (item.terms[j].value === '') {
            //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
            //                  return
            //                }
            //              }
            // 如果是微信回复
            if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
              if (item.terms[j].value === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                return
              }
              if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                return
              }
            }
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              console.log('102')
              if (item.terms[j].selectedOptions[1] !== 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                }
              }
              if (item.terms[j].selectedOptions[1] === 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent.length === 0) {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                  if (yi.attributeRelation === 'gtele') {
                    if (yi.attrValTimeStart === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                      return
                    }
                    if (yi.attrValTimeEnd === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                      return
                    }
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      this.is_searched = true
      this.searchQuery()
    },
    // 开始高级查询
    searchQuery () {
      // 判断是否为空
      if (this.isShowSearchRes === false) {
        for (let i in this.allTerms.termsGroup) {
          let item = this.allTerms.termsGroup[i]
          for (let j in item.terms) {
            if (item.terms[j].selectedOptions[0] === 'attr') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
            }
            // 判断客户属性是否为空
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].attr === 'attr') {
                // 判断是否是时间且为区间
                if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                  if (item.terms[j].relationship === 'gtele') {
                    if (item.terms[j].start_time === '') {
                      _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                      return
                    }
                    if (item.terms[j].end_time === '') {
                      _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                      return
                    }
                  } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
            }
            // 判断群组是否为空
            if (item.terms[j].attr === 'group') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
            // 判断客户事件是否为空
            if (item.terms[j].attr === 'event') {
              // 需要选内容的
              //              if (
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
              //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
              //              ) {
              //                if (item.terms[j].value === '') {
              //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
              //                  return
              //                }
              //              }
              // 如果是微信回复
              if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
                if (item.terms[j].value === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                  return
                }
                if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                  return
                }
              }
              // 限制属性
              if (item.terms[j].eventLimitAttr === true) {
                console.log('102')
                if (item.terms[j].selectedOptions[1] !== 'order') {
                  for (let yi of item.terms[j].eventAttrOptions) {
                    if (yi.attributeContent === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                      return
                    }
                    if (yi.attributeRelation === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                      return
                    }
                    if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                      if (yi.attributeValue === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                        return
                      }
                    }
                  }
                }
                if (item.terms[j].selectedOptions[1] === 'order') {
                  for (let yi of item.terms[j].eventAttrOptions) {
                    if (yi.attributeContent.length === 0) {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                      return
                    }
                    if (yi.attributeRelation === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                      return
                    }
                    if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                      if (yi.attributeValue === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                        return
                      }
                    }
                    if (yi.attributeRelation === 'gtele') {
                      if (yi.attrValTimeStart === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                        return
                      }
                      if (yi.attrValTimeEnd === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                        return
                      }
                    }
                  }
                }
              }
              // 限制起止时间
              if (item.terms[j].eventLimitTime === true) {
                if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                  _g.toastMsg('error', '请选择起止时间')
                  return
                }
              }
              // 限制发生次数
              if (item.terms[j].eventCheckbox2 === true) {
                if (item.terms[j].eventSearchTimesSelect === '') {
                  _g.toastMsg('error', '请选择发生次数相对关系')
                  return
                }
                if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                  if (item.terms[j].happenedTimes === '') {
                    _g.toastMsg('error', '发生次数不能为空')
                    return
                  }
                }
                if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                  if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                    _g.toastMsg('error', '发生次数区间值不能为空')
                    return
                  }
                }
              }
            }
            // 判断关注公众号是否为空
            if (item.terms[j].attr === 'follow_public') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
            // 判断客户身份是否为空
            if (item.terms[j].attr === 'customer_identity') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
                if (item.terms[j].value === '' || item.terms[j].value === null) {
                  _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
            }
            // 判断关客户关键指标是否为空
            if (item.terms[j].attr === 'customer_kpi') {
              if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
                if (item.terms[j].relationship === '') {
                  _g.toastMsg('error', '请选择相对关系')
                  return
                }
                if (item.terms[j].relationship !== 'gtele') {
                  if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                    _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                    return
                  }
                }
                if (item.terms[j].relationship === 'gtele') {
                  if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                    _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                    return
                  }
                }
              }
            }
          }
        }
      }
      this.loadList = true
      this.page = 1
      this.lastId = ''
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          // one.option = null
          // one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
          // one.eventAttributeList = null

          // for (let yi of one.eventAttrOptions) {
          // yi.eventAttrValueOptions = null
          // yi.relationOptions = null
          // }
        }
      }
      console.log('query', termsSend)
      // 过滤不必要的参数
      // let termData = _g.getCondition(termsSend)
      getCustomerList(this.page, this.lastId, termsSend).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data.list
          this.result = []
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.tableData = this.result[0]
          this.totalCount = res.data.data.count
          this.exportNumber = res.data.data.count
        }
        this.loadList = false
        // this.openLoading()
      })
      // 保存筛选条件到本地
      this.setQuery(this.allTerms)
    },
    // 收起筛选和展开筛选
    closeAndOpen () {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.lastId = this.tableData[this.tableData.length - 1].id
    },
    handleCurrentChange (page) {
      this.page = page
      this.tableData = this.result[page - 1]
      this.lastId = this.tableData[this.tableData.length - 1].id
      console.log('111111', this.searchType)
      if (this.lastId === this.result[this.result.length - 1][9].id) {
        if (this.searchType === 1) {
          console.log('mmmmmm')
          let termsSend = this.allTerms
          for (let item of termsSend.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              // one.option = null
            }
          }
          getCustomerList(this.page, this.lastId, termsSend).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.tableData = this.result[page - 1]
              this.totalCount = res.data.data.count
              this.exportNumber = res.data.data.count
            }
          })
        } else if (this.searchType === 0) {
          console.log('wowowwowwow')
          getCustomerList(this.page, this.lastId, this.search).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.tableData = this.result[page - 1]
              this.totalCount = res.data.data.count
              this.exportNumber = res.data.data.count
            }
          })
        } else if (this.searchType === 2) {
          let termsArr = {}
          for (let item of this.searchOptions) {
            if (item.id == this.changeSearchValue) {
              termsArr = item.query
            }
          }
          getCustomerList(this.page, this.lastId, termsArr).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.tableData = this.result[page - 1]
              this.totalCount = res.data.data.count
              this.exportNumber = res.data.data.count
            }
          })
        }
      }
    },
    // 加载列表
    load () {
      console.log('222222', this.searchType)
      this.loadList = true
      let querys = {}
      if (this.hide === false) {
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            // one.option = null
            one.relationOptions = null
            one.optionOther = null
            one.qrcodeOptions = null
            one.templateOption = null
          }
        }
        querys = termsSend
        console.log('521', querys)
      } else {
        querys = this.search
      }
      getCustomerList(this.page, this.lastId, querys).then((res) => {
        this.loadList = false
        if (res.data.code === 0) {
          this.result = []
          let data = res.data.data.list
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.tableData = this.result[0]
          this.totalCount = res.data.data.count
          this.exportNumber = res.data.data.count
        }
        this.openLoading()
      })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loadList = false
      }, 500)
    },
    // 删除
    deleteItem (item) {
      this.$confirm('确认删除该客户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomer(item.id).then((res) => {
          setTimeout(() => {
            if (res.data.code === 0) {
              this.lastId = 0
              this.page = 1
              this.load(this.page, this.lastId, this.search)
            }
          }, 1000)
        })
      })
    },
    // 弹窗确定
    confirmAdd () {
      let reg = new RegExp('^\\s*\\w+(?:\\.{0,1}[\\w-]+)*@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\\.[a-zA-Z]+\\s*$')
      if (!reg.test(this.addForm.email)) {
        _g.toastMsg('error', '请输入正确邮箱')
        return
      }
      // 添加弹窗
      this.isDisabled = true
      addCustomer(this.addForm.name, this.addForm.phone, this.addForm.mobile_verified, this.addForm.sex, this.addForm.email, this.addForm.email_verified).then((res) => {
        if (res.data.code === 0) {
          this.adddialog = false
          this.isDisabled = false
          this.addForm.name = ''
          this.addForm.phone = ''
          this.addForm.email = ''
          setTimeout(() => {
            this.load()
          }, 2000)
          _g.toastMsg('success', '添加成功')
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 打开添加弹窗
    openDialog () {
      this.adddialog = true
      this.addForm.name = ''
      this.addForm.phone = ''
      this.addForm.email = ''
    },
    // 关闭弹窗
    cancelAdd () {
      this.adddialog = false
    }
  },
  // 修改列表页的meta值，false时再次进入页面会重新请求数据。
  //  beforeRouteLeave(to, from, next) {
  //    from.meta.keepAlive = false
  //    to.meta.keepAlive = false
  //    next()
  //  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      let query = JSON.parse(sessionStorage.getItem('customerQuery'))
      vm.isShowSearchRes = true
      if (query) {
        for (let one of query.termsGroup) {
          for (let item of one.terms) {
            // 回显属性
            if (item.selectedOptions[0] === 'attr') {
              // 回显客户等级与来源
              if (item.selectedOptions[1].split('@')[0] === 'source_id') {
                getSourceData().then((res) => {
                  item.option = res.data.data.list
                })
              }
              if (item.selectedOptions[1].split('@')[0] === 'stage_id') {
                getCustomerStage().then((res) => {
                  item.option = res.data.data
                  item.option.unshift({
                    name: '未知等级',
                    id: 0
                  })
                })
              }
              /* -------------自定义属性的相对关系------------ */
              // 文本
              if (item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 下拉
              if (item.selectedOptions[1].split('@')[1] === 'select') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 日期
              if (item.selectedOptions[1].split('@')[1] === 'datePicker') {
                item.relationOptions = [
                  {
                    value: 'gt',
                    label: '晚于'
                  }, {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'lt',
                    label: '早于'
                  }, {
                    value: 'gtele',
                    label: '区间'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 位置
              if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 单选
              if (item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 复选
              if (item.selectedOptions[1].split('@')[1] === 'checkBox') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              /* -------------系统属性的相对关系------------ */
              // 真实姓名
              if (item.selectedOptions[1].split('@')[0] === 'realname' && item.selectedOptions[1].split('@')[1] === 'input') {
                console.log('502')
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 性别
              if (item.selectedOptions[1].split('@')[0] === 'sex' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }
                ]
              }
              // 当前等级
              if (item.selectedOptions[1].split('@')[0] === 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }
                ]
              }
              // 微信号
              if (item.selectedOptions[1].split('@')[0] === 'wechat' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 省市区
              if (item.selectedOptions[1].split('@')[0] === 'systemPcd' && item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 初始来源
              if (item.selectedOptions[1].split('@')[0] === 'source_id' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 手机号
              if (item.selectedOptions[1].split('@')[0] === 'mobile' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 手机号验证
              if (item.selectedOptions[1].split('@')[0] === 'mobile_verified' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }
                ]
              }
              // 座机号
              if (item.selectedOptions[1].split('@')[0] === 'phone' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 邮箱
              if (item.selectedOptions[1].split('@')[0] === 'email' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 邮箱验证
              if (item.selectedOptions[1].split('@')[0] === 'email_verified' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }
                ]
              }
              // 生日
              if (item.selectedOptions[1].split('@')[0] === 'birthday' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
                item.relationOptions = [
                  {
                    value: 'gt',
                    label: '晚于'
                  }, {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'lt',
                    label: '早于'
                  }, {
                    value: 'gtele',
                    label: '区间'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 家庭住址
              if (item.selectedOptions[1].split('@')[0] === 'home_address' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 公司名称
              if (item.selectedOptions[1].split('@')[0] === 'company' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 公司地址
              if (item.selectedOptions[1].split('@')[0] === 'company_address' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 备注
              if (item.selectedOptions[1].split('@')[0] === 'remark' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 行业
              if (item.selectedOptions[1].split('@')[0] === 'industry' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 职位
              if (item.selectedOptions[1].split('@')[0] === 'position' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 是否会员
              if (item.selectedOptions[1].split('@')[0] === 'is_vip' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }
                ]
              }
              // 身份证号
              if (item.selectedOptions[1].split('@')[0] === 'id_number' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 昵称
              if (item.selectedOptions[1].split('@')[0] === 'nickname' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 创建时间
              if (item.selectedOptions[1].split('@')[0] === 'create_time' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
                item.relationOptions = [
                  {
                    value: 'gt',
                    label: '晚于'
                  }, {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'lt',
                    label: '早于'
                  }, {
                    value: 'gtele',
                    label: '区间'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 最后修改时间
              if (item.selectedOptions[1].split('@')[0] === 'update_time' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
                item.relationOptions = [
                  {
                    value: 'gt',
                    label: '晚于'
                  }, {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'lt',
                    label: '早于'
                  }, {
                    value: 'gtele',
                    label: '区间'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // QQ
              if (item.selectedOptions[1].split('@')[0] === 'qq' && item.selectedOptions[1].split('@')[1] === 'input') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 是否本公司员工
              if (item.selectedOptions[1].split('@')[0] === 'self_company' && item.selectedOptions[1].split('@')[1] === 'radio') {
                item.relationOptions = [
                  {
                    value: '=',
                    label: '等于'
                  }
                ]
              }
            }
            // 回显群组
            if (item.selectedOptions[0] === 'group') {
              getGroupList(1, '', 0).then((res) => {
                for (let item of res.data.data.list) {
                  item.label = item.name
                  item.value = item.id
                }
                console.log('re', res)
                item.option = res.data.data.list
              })
            }
            // 回显事件
            if (item.selectedOptions[0] === 'event') {
              // 回显微信公众号
              if (item.selectedOptions[1] === 'wechat') {
                getWechatPublicListForNode(1, '').then((res) => {
                  res.data.data.list.unshift({
                    label: '不限',
                    nick_name: '不限',
                    id: '',
                    value: ''
                  })
                  for (let ite of res.data.data.list) {
                    ite.label = ite.nick_name
                    ite.value = ite.id
                    // 扫描线下活动二维码
                    if (item.selectedOptions[2].split('@')[0] === 'scan_offline_qrcode') {
                      if (item.value === ite.id) {
                        item.optionOther = ite.offline
                      }
                    }
                    // 扫描公众号二维码
                    if (item.selectedOptions[2].split('@')[0] === 'scan_qrcode') {
                      if (item.value === ite.id) {
                        item.qrcodeOptions = ite.qrcode
                      }
                      getQrCodeList().then((res) => {
                        console.log('res', res)
                      })
                    }
                    // 发送模板消息
                    if (item.selectedOptions[2].split('@')[0] === 'send_tpl_message') {
                      if (item.value === ite.id) {
                        item.templateOption = ite.template
                      }
                    }
                  }
                  item.option = res.data.data.list
                  console.log('this.forSonTerms', this.forSonTerms)
                })
              }
              // 回显微页面
              if (item.selectedOptions[1] === 'wepage') {
                WePagesList(1, { publish_status: '' }).then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.admin_title
                    ite.value = ite.id
                  }
                  item.option = res.data.data.list
                })
              }
              // 回显短信
              if (item.selectedOptions[1] === 'sms') {
                getMessageListForNode(1, '').then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.sms_name
                    ite.value = ite.id
                  }
                  item.option = res.data.data.list
                })
              }
              // 回显互动活动（大转盘）
              if (item.selectedOptions[1] === 'interactive_activities') {
                getBigWheelList().then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.name
                    ite.value = ite.id
                  }
                  item.option = res.data.data.list
                })
              }
            }
            // 回显关注公众号
            if (item.selectedOptions[0] === 'follow_public') {
              // 回显微信公众号
              getWechatPublicListForNode(1, '').then((res) => {
                for (let ite of res.data.data.list) {
                  ite.label = ite.nick_name
                  ite.value = ite.id
                }
                item.option = res.data.data.list
                console.log('this.forSonTerms', this.forSonTerms)
              })
            }
            // 回显客户身份
            if (item.selectedOptions[0] === 'customer_identity') {
              item.relationOptions = [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ]
            }
            // 回显微页面
            if (item.selectedOptions[1] === 'wepage') {
              WePagesList(1, { publish_status: '' }).then((res) => {
                for (let ite of res.data.data.list) {
                  ite.label = ite.admin_title
                  ite.value = ite.id
                }
                item.option = res.data.data.list
              })
            }
            // 回显短信
            if (item.selectedOptions[1] === 'sms') {
              getMessageListForNode(1, '').then((res) => {
                for (let ite of res.data.data.list) {
                  ite.label = ite.sms_name
                  ite.value = ite.id
                }
                item.option = res.data.data.list
              })
            }
            // 回显互动活动（大转盘）
            if (item.selectedOptions[1] === 'interactive_activities') {
              getBigWheelList().then((res) => {
                for (let ite of res.data.data.list) {
                  ite.label = ite.name
                  ite.value = ite.id
                }
                item.option = res.data.data.list
              })
            }
            // 客户关键指标
            if (item.selectedOptions[0] === 'customer_kpi') {
              item.relationOptions = [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'gt',
                  label: '大于'
                },
                {
                  value: 'lt',
                  label: '小于'
                },
                {
                  value: 'gtele',
                  label: '区间'
                }
              ]
            }
          }
        }
        vm.allTerms = query
        vm.hide = false
        console.log('dawda')
        vm.forSonTerms = vm.allTerms.termsGroup
        vm.allRelationshipSearch = vm.allTerms.allRelationship
        sessionStorage.removeItem('customerQuery')
        vm.searchType = 1
        vm.is_searched = true
      } else {
        vm.allTerms = {
          allRelationship: 'and',
          termsGroup: [
            {
              inOperator: 'and',
              terms: [
                {
                  attr: 'attr',
                  attr_label: '真实姓名',
                  relationship: '',
                  relationOptions: [
                    {
                      value: '=',
                      label: '等于'
                    }, {
                      value: '!=',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not empty',
                      label: '不为空'
                    }
                  ],
                  value: null,
                  original_id: null,
                  eventAttributeList: [],
                  activitiesTwo: [],
                  templatesTwo: [],
                  wepageTwo: [],
                  eventAttrOptions: [
                    {
                      attributeContent: '',
                      relationOptions: [],
                      sources: [],
                      eventAttrValueOptions: [],
                      attributeRelation: '',
                      attr_type: '',
                      attrValTimeStart: '',
                      attrValTimeEnd: '',
                      attributeValueStart: '',
                      attributeValueEnd: '',
                      attributeValue: ''
                    }
                  ],
                  optionOther: null,
                  qrcodeOptions: null,
                  templateOption: null,
                  qrcode: null,
                  offline_qrcode: null,
                  template_id: null,
                  leave_word: null,
                  public_reply_type_all: {
                    reply_type: '不限',
                    reply_content: ''
                  },
                  eventLimitTime: false,
                  eventLimitTimes: false,
                  eventLimitAttr: false,
                  eventTimeRelation: '',
                  eventDateStart: '',
                  eventDateEnd: '',
                  happenedTimes: '',
                  start_time: '',
                  end_time: '',
                  selectedOptions: ['attr', 'realname@input']
                }
              ]
            }
          ]
        }
        vm.forSonTerms = [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '真实姓名',
                relationship: '',
                relationOptions: [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ],
                value: null,
                original_id: null,
                eventAttributeList: [],
                activitiesTwo: [],
                templatesTwo: [],
                wepageTwo: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                optionOther: null,
                qrcodeOptions: null,
                templateOption: null,
                qrcode: null,
                offline_qrcode: null,
                template_id: null,
                leave_word: null,
                public_reply_type_all: {
                  reply_type: '不限',
                  reply_content: ''
                },
                eventLimitTime: false,
                eventLimitTimes: false,
                eventLimitAttr: false,
                eventTimeRelation: '',
                eventDateStart: '',
                eventDateEnd: '',
                happenedTimes: '',
                start_time: '',
                end_time: '',
                selectedOptions: ['attr', 'realname@input']
              }
            ]
          }
        ]
        vm.hide = true
      }
      vm.searchQuery()
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.path === '/home/customer-detail') {
      console.log('wozhendeshihahhaaaaaaa', this.is_searched)
      if (this.is_searched === true) {
        console.log('wozhendeshi')
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            one.option = null
            // one.relationOptions = null
            // one.optionOther = null
            // one.qrcodeOptions = null
            // one.templateOption = null
            // one.eventAttributeList = null

            // for (let yi of one.eventAttrOptions) {
            // yi.eventAttrValueOptions = null
            // yi.relationOptions = null
            // }
          }
        }
        sessionStorage.setItem('customerQuery', JSON.stringify(termsSend))
        sessionStorage.setItem('customerQueryIsShow', '1')
      }
    } else {
      sessionStorage.setItem('customerQueryIsShow', '0')
      this.is_searched = false
    }
    next()
  },
  created () {
    let query = JSON.parse(sessionStorage.getItem('customerQuery'))
    if (!query) {
      this.load()
    }
    this.getCustomerAttributes()
    this.getQueryconditionAction()
  }
}
</script>

<style scoped>
.export-number {
  text-align: left;
  margin-bottom: 20px;
}
.save-btn {
  padding: 0 10px;
  height: 30px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #1890FF;
  cursor: pointer;
  border: none;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}

/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
</style>
